import methods from "./methods";
import Cell, { ColumnValue, RowsCell } from "./Cell";

const setValue = ({
  parent,
  children,
  valueIndex,
  column,
  isRoot,
  method,
  event,
  dataIndex,
  modifier,
  isLeaf,
  key
}) => {

  const defaultValue: string = event[valueIndex];  
  const cell = Cell.newCellValue({ value: defaultValue, method, parent,key:children.id });
  const { __suffix = {}, __prefix = {}, __color = {} } = modifier;

  if (__suffix[dataIndex]) {
    cell.formatter.suffix = __suffix[dataIndex];
  }
  if (__prefix[dataIndex]) {
    cell.formatter.prefix = __prefix[dataIndex];
  }
  if (__color[dataIndex]) {
    cell.formatter.color = __color[dataIndex];
  }
  cell.id = key
  cell.key = key
  
  switch (method) {
    case methods.formated:
      cell.value = event["__format"][dataIndex];
      cell.method = methods.formated;          
      children.set(column, cell);
      break;
    default:
      children.set(column, cell);
      break;
  }
  
  if (isLeaf && !isRoot) {
    setParentValue(parent, column);
  }
  
};

function setParentValue(parent: RowsCell, column: string) {
  const children = [...parent.children] as RowsCell[];
  const columnValue: ColumnValue = {...parent[column]};

  switch (columnValue.method) {
    case methods.avg:
      const sumParent = children.reduce(
        (state: number, child: RowsCell): number => {
          const cell_child = {...child[column]} as ColumnValue;
          if (cell_child) {
            try {
              const newValue = parseFloat(cell_child.value.toString());
              if (isFinite(newValue)) {
                state += newValue;
              }
            } catch (error) {}
          }
          return state;
        },
        0
      );
      const countParent = children.length;
      columnValue.value = Math.round((sumParent / countParent) * 100) / 100;
      parent.set(column, columnValue);

      break;

    case methods.sum:
      const sumParentSum = children.reduce(
        (state: number, child: RowsCell): number => {
          const cell_child = child[column] as ColumnValue;
          if (cell_child) {
            try {
              const newValue = parseFloat(cell_child.value.toString());
              if (isFinite(newValue)) {
                state += newValue;
              }
            } catch (e) {}
          }
          return state;
        },
        0
      );

      columnValue.value = Math.round(sumParentSum * 100) / 100;
      parent.set(column, columnValue);

      break;
    default:
      break;
  }

  if (!Array.isArray(columnValue.parent) && columnValue.parent) {
    setParentValue(columnValue.parent, column);
  }
}

export default setValue;
